<template>
  <custom-dialog width="520px" :title="model.title" :visible="visible" v-on="$listeners" append-to-body>
    <div class="dialog-body">
      <el-form :model="form" label-position="top" :rules="rules" ref="form" label-width="92px">
        <el-form-item :label="$t('dms_location_site_select_dialog.xiang_mu_ming_cheng')" prop="locationId">
          <el-input size="small" v-model="form.locationName" style="width: 340px" :disabled="true"></el-input>
          <el-button size="small" style="margin-left: 8px" type="primary" @click="onSelectLocation()">
            {{ $t('dms_location_site_select_dialog.xuan_ze_xiang_mu') }}
          </el-button>
        </el-form-item>
        <el-form-item :label="$t('dms_location_site_select_dialog.qu_yu')" prop="siteId">
          <el-input size="small" v-model="form.siteName" style="width: 340px" :disabled="true"></el-input>
          <el-button size="small" style="margin-left: 8px" type="primary" @click="onSelectSite()" :disabled="!form.locationId">
            {{ $t('dms_location_site_select_dialog.xuan_ze_qu_yu') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :disabled="!form.locationId || !form.siteId" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择项目 -->
    <location-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onLocationConfirm"></location-select-dialog>
    <!-- 选择区域 -->
    <site-select-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onSiteConfirm"></site-select-dialog>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import locationSelectDialog from '@/pages/dms/components/location_select_dialog.vue';
import siteSelectDialog from '@/pages/dms/components/site_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { locationSelectDialog, siteSelectDialog },
  data() {
    return {
      form: {
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',

        // 地址
        address: '',
        detailAddress: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
      },
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  computed: {
    rules() {
      return {
        locationId: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        siteId: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.form.locationId = this.model.row.locationId || '';
      this.form.locationName = this.model.row.locationName || '';
      this.form.siteId = this.model.row.siteId || '';
      this.form.siteName = this.model.row.siteName || '';
    },
    // 选择项目
    onSelectLocation: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_location_site_select_dialog.xuan_ze_xiang_muo', [this.model.row.orgName]);
      this.dialogModel.data = {
        orgId: this.model.row.orgId,
        orgName: this.model.row.orgName,
      };
      this.dialogVisible = true;
    },
    // 选择区域
    onSelectSite: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('dms_location_site_select_dialog.xuan_ze_qu_yuo', [this.form.locationName]);
      this.dialogModel1.data = {
        orgId: this.model.row.orgId,
        orgName: this.model.row.orgName,
        locationId: this.form.locationId,
      };
      this.dialogVisible1 = true;
    },
    onLocationConfirm: function (row) {
      this.form.locationId = row.locationId;
      this.form.locationName = row.locationName;
      this.form.address = row.address;
      this.form.detailAddress = row.detailAddress;
      this.form.countryCode = row.countryCode;
      this.form.provinceCode = row.provinceCode;
      this.form.cityCode = row.cityCode;
      this.form.siteId = '';
      this.form.siteName = '';
    },
    onSiteConfirm: function (row) {
      this.form.siteId = row.siteId;
      this.form.siteName = row.siteName;
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit('success', { ...this.form, row: this.model.row });
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
